import React, { useRef } from 'react'
import { Calendar } from 'primereact/calendar';

function DateRangeSelection({ dates, setDates }) {
    const calendarRef = useRef(null);

    const handleDateSelect = (e) => {
        setDates(e.value);

        if (e.value[0] !== null && calendarRef.current && e.value[1] !== null) {
            calendarRef.current.hide();
        }
    };

    return (
        <Calendar
            value={dates}
            onChange={handleDateSelect}
            selectionMode="range"
            readOnlyInput
            ref={calendarRef}
            hideOnDateTimeSelect
            dateFormat="dd/mm/yy"
        />
    )
}

export default DateRangeSelection